import { RentalService } from './../rental.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Animations } from 'src/app/_helpers/animations';

@Component({
  selector: 'app-rental-modal-filter',
  templateUrl: './rental-modal-filter.component.html',
  styleUrls: ['./rental-modal-filter.component.scss'],
  animations: [Animations.animeHeight, Animations.animeRotate],

})
export class RentalModalFilterComponent implements OnInit {

  @Input()
    statusOptions: [{
      id: string,
      name: string
    }];


  @Output()
    newStatusToFilter: EventEmitter<string> = new EventEmitter<string>();
  
  showStatusOptions: boolean = false;
  numberOfELements: number;
  
  constructor(
    private modalCtrl: ModalController,
    public rentalServ: RentalService
  ) {

  }

  ngOnInit() {

  }

  onStatusChange(event){
    this.rentalServ.setCurrentStatus(event.detail.value);
  }

  onClearFilters() {
    this.rentalServ.setCurrentStatus('ALL');
  }

  onClose() {
    this.modalCtrl.dismiss("", "backdrop");
  }

}


